import "./PortfolioRoadmap.css";

import { Dispatch, memo, SetStateAction } from "react";
import { JSX } from "react/jsx-runtime";
import { Chart } from "react-google-charts";

import { PortfolioDatesData } from "../../../models";
import { Toggle } from "../../forms";
import { LoadingSpinner } from "../LoadingSpinner";
import { PortfolioRoadmapRowLabels, ViewModeOptions } from "./components";
import { usePortfolioRoadmap } from "./usePortfolioRoadmap";

interface PortfolioRoadmapProps {
  data: PortfolioDatesData[];
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  headerLabel?: string;
}

export const PortfolioRoadmap = memo(
  ({ data, isLoading, setIsLoading, headerLabel }: PortfolioRoadmapProps): JSX.Element => {
    const {
      chartData,
      rowLabelData,
      options,
      chartEvents,
      height,
      viewMode,
      showMilestones,
      width,
      roadmapRef,
      rowLabelsRef,
      onChangeViewMode,
      onToggleMilestones,
      onScroll,
    } = usePortfolioRoadmap({ data, setIsLoading });

    return data.length > 0 ? (
      <div className="PortfolioRoadmap">
        <div className="PortfolioRoadmapTopBar">
          <Toggle value={showMilestones} onChange={onToggleMilestones} label="Show milestones" labelAlignment="left" />
          <ViewModeOptions viewMode={viewMode} onChangeViewMode={onChangeViewMode} />
        </div>
        <div ref={roadmapRef} className={`PortfolioRoadmapContainer ${isLoading ? "Hidden" : ""}`} onScroll={onScroll}>
          <PortfolioRoadmapRowLabels ref={rowLabelsRef} data={rowLabelData} headerLabel={headerLabel} />
          <Chart
            chartType="Timeline"
            data={chartData}
            width={width}
            height={`${height}px`}
            options={options}
            chartEvents={chartEvents}
            chartVersion="51"
          />
        </div>
        {isLoading && <LoadingSpinner size="medium" type="dark" />}
      </div>
    ) : (
      <p className="body2 NoData">No roadmap data available</p>
    );
  }
);
